import en from './en/translation.json'

const resources = {
  en: {
    translation: en,
  },
}

export default resources
